import React from 'react';
import { Content } from './shared';

const AetnaLasik = () => (
  <Content>
    Imagine your world without glasses. Learn more about your discount on LASIK eye surgery on the
    US Laser Network's website.
  </Content>
);

export default AetnaLasik;
